// extracted by mini-css-extract-plugin
export default {"root":"NOmboip2","title":"w4bf9oJ7","content":"pOQrZmsd"};